import { RefObject, useEffect, useRef } from 'react';

export function useHorizontalScroll<T extends HTMLElement>(
  callbackRef?: React.RefCallback<T>,
): RefObject<T> {
  const scrollRef = useRef<T>(null);
  useEffect(() => {
    callbackRef?.(scrollRef.current ?? null);
    const el = scrollRef.current;
    const onWheel = (e: WheelEvent) => {
      if (el === null || e.deltaY === 0) return;
      e.preventDefault();
      el.scrollTo({
        left: el.scrollLeft + e.deltaY,
        behavior: 'smooth',
      });
    };
    if (el) {
      el.addEventListener('wheel', onWheel);
    }
    return () => el?.removeEventListener('wheel', onWheel);
  }, [callbackRef]);
  return scrollRef;
}
